import { Box, FileUploadZone } from '@domain-group/suit-theme'

import useUppyArtworkUpload from '@hooks/useUppyArtworkUpload'

import type { ArtworkModel } from '@models/types'

interface ArtworkUploadProps {
  artwork: Partial<ArtworkModel>,
  callbacks: {
    closeModal: () => void,
    manageOrderItem: () => void,
  },
}

const ArtworkUpload = (props: ArtworkUploadProps) => {
  const {
    artwork,
    callbacks,
  } = props

  const {
    id,
    campaign_id,
    campaign_item_id,
    campaign_quote_item_id,
    order_item_id,
    service_product_id,
  } = artwork

  const { closeModal, manageOrderItem } = callbacks

  const uppyOptions = {
    artwork_id: id,
    callbacks: {
      afterAction: () => {
        manageOrderItem()
        closeModal()
      },
    },
    campaign_id,
    campaign_item_id,
    campaign_quote_item_id,
    endpoint: 'artworks/upload.json',
    order_item_id,
    service_product_id,
  }

  const uppy = useUppyArtworkUpload(
    uppyOptions,
    // @ts-expect-error TS2322
    [id, campaign_item_id, campaign_quote_item_id, order_item_id, service_product_id],
  )

  return (
    <Box padding="large">
      <FileUploadZone subTitle="Drop file here or click to upload (Max 50mb)" uppy={uppy} />
    </Box>
  )
}

export default ArtworkUpload
